import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import WarningIcon from '../icons/warning.svg';

const AlertItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
}));

const AlertIcon = styled('img')(({ theme }) => ({
  width: 16,
  height: 16,
  marginTop: 2,
  flexShrink: 0,
}));

const AlertText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#4A5568',
  lineHeight: 1.4,
}));

const AlertsWarnings: React.FC = () => {
  const alerts = [
    'PandaDoc API usage nearing capacity',
    'Slow query response time detected',
    '2 Expiring Contracts In 30 days',
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
        Alerts & Warnings
      </Typography>
      {alerts.map((alert, index) => (
        <AlertItem key={index}>
          <AlertIcon src={WarningIcon} alt="Warning" />
          <AlertText>{alert}</AlertText>
        </AlertItem>
      ))}
    </Box>
  );
};

export default AlertsWarnings; 